import { Slide, parseContent } from '@features/powerpoint';
import { theme } from '../../../domain/theme';
import { coverSlide } from '@features/executive-report/slides';

export const campaignInsightsCoverSlide = (): Slide => {
  const baseCoverSlide = coverSlide({
    titleText: parseContent('<lci>Campaign</lci> Insights', 0, {
      charSpacing: theme.charSpacing.tight,
    }),
    bold: false,
  });

  return {
    ...baseCoverSlide,
    texts: [
      ...(baseCoverSlide.texts ?? []),
      {
        text: 'Insights into consumers that were exposed to and engaged with your media',
        options: {
          fontSize: 18,
          color: theme.colors.white,
          h: 1.01,
          w: 4.01,
          x: 7.05,
          y: 3.59,
        },
      },
    ],
    shapes: [
      ...(baseCoverSlide.shapes ?? []),
      {
        shapeName: 'line',
        options: {
          line: {
            color: theme.colors.inmarketGreen,
            width: 2.25,
          },
          h: 3.67,
          w: 0,
          x: 6.67,
          y: 1.96,
        },
      },
    ],
  };
};
